import UsersListV2Scene from '@/components/scenes/v2/UsersListV2Scene';

export default function UserCreatedV2Scene() {
  return <UsersListV2Scene showSuccessToast={true} />;
}
